import type { GridRowSpacingParams } from '@mui/x-data-grid';
import type { Theme } from '@mui/material/styles';
import palette from './palette';

const datagrid = {
  MuiDataGrid: {
    defaultProps: {
      columnHeaderHeight: 56,
      rowHeight: 48,
      rowSpacingType: 'margin',
      getRowSpacing: ({ isFirstVisible }: GridRowSpacingParams) => ({
        top: isFirstVisible ? 0 : 8,
        bottom: 0,
      }),
    },
    styleOverrides: {
      root: {
        '--DataGrid-rowBorderColor': palette.grey[200],
        '--unstable_DataGrid-radius': '6px',
        backgroundColor: 'transparent',
        border: 0,
        fontSize: '16px',
        '& .MuiDataGrid-columnSeparator': {
          display: 'none',
        },
      },
      columnHeaders: {
        border: `1px solid ${palette.grey[200]}`,
        borderBottom: 0,
        '& .MuiDataGrid-row--borderBottom': {
          paddingBottom: 8,
          position: 'relative',
          '&::after': {
            content: '""',
            position: 'absolute',
            left: -1,
            right: -1,
            bottom: 0,
            height: 8,
            backgroundColor: palette.grey[150],
          },
        },
      },
      columnHeader: ({ theme }: { theme: Theme }) => ({
        '--DataGrid-t-header-background-base': 'transparent',
        transition: theme.transitions.create(
          ['background-color']
        ),
        '&:hover': {
          backgroundColor: palette.grey[100],
        },
      }),
      scrollbarFiller: {
        '--DataGrid-t-header-background-base': 'transparent',
      },
      row: ({ theme }: { theme: Theme }) => ({
        backgroundColor: palette.common.white,
        border: `1px solid ${palette.grey[200]}`,
        transition: theme.transitions.create(
          ['background-color', 'border-color', 'color']
        ),
        '&.MuiDataGrid-row--lastVisible': {
          borderBottomLeftRadius: 'var(--unstable_DataGrid-radius)',
          borderBottomRightRadius: 'var(--unstable_DataGrid-radius)',
        },
        '&:hover': {
          backgroundColor: palette.common.black,
          color: palette.common.white,
          '& .MuiIconButton-root': {
            color: palette.common.white,
          },
        },
      }),
      cell: {
        border: 0,
        '&:focus, &:focus-within': {
          outline: 'none',
        },
      },
    },
  },
};

export default datagrid;
